import SOCKET_EVENTS from './socketEvents';

// Notification templates used across the app for socket-triggered notifications
// Each template may provide: title(function|string), message(function|string), type, sound, pwaOptions, toastOptions
export const SOCKET_NOTIFICATION_TEMPLATES = {
  [SOCKET_EVENTS.LEG_NOTIFICATION]: {
    title: (payload) => payload?.title || 'Parcel Notification',
    message: (payload) => payload?.message || '',
    type: 'info',
    sound: '/sounds/notify1.mp3',
    pwaOptions: (payload) => ({ body: payload?.message }),
    toastOptions: (payload) => ({
      title: payload?.title,
      message: payload?.message,
      position: 'top-right',
      duration: 6000,
      severity: 'info',
    }),
  },
  [SOCKET_EVENTS.PARCEL_STATUS_UPDATE]: {
    title: (payload) => `Parcel ${payload?.parcelId || ''}`,
    message: (payload) => (payload?.status ? `Status: ${payload.status}` : 'Parcel status updated'),
    type: 'success',
    sound: '/sounds/notify1.mp3',
    pwaOptions: (payload) => ({ body: payload?.status }),
    toastOptions: (payload) => ({
      title: `Parcel ${payload?.parcelId || ''}`,
      message: payload?.status,
      position: 'top-right',
      duration: 6000,
      severity: 'success',
    }),
  },
  [SOCKET_EVENTS.RIDER_LOCATION_UPDATE]: {
    title: (payload) => 'Rider Location Updated',
    message: (payload) => `Rider is at (${payload?.lat ?? 'N/A'}, ${payload?.lng ?? 'N/A'})`,
    type: 'info',
    sound: null,
    pwaOptions: (payload) => ({ body: `Live location update` }),
    toastOptions: (payload) => ({
      title: 'Rider location updated',
      message: '',
      position: 'top-right',
      duration: 4000,
      severity: 'info',
    }),
  },
};

export default SOCKET_NOTIFICATION_TEMPLATES;
